export default __webpack_public_path__ + "static/media/boardgames.5d87d068.jpg";